import {defineMessages} from 'react-intl';
import Icon from 'components/Icon';

const MESSAGES = defineMessages({
  BUZZ_MESSAGE: {
    id: 'SearchConstants__ENTITY_TYPES_BUZZ_MESSAGE',
    description: 'Buzz Messages label for search filters',
    defaultMessage: 'Buzz Messages',
  },
  BUZZ_CHANNEL: {
    id: 'SearchConstants__ENTITY_TYPES_BUZZ_CHANNEL',
    description: 'Buzz Channels label for search filters',
    defaultMessage: 'Buzz Channels',
  },
  CARD: {
    id: 'SearchConstants__ENTITY_TYPES_CARDS',
    description: 'Cards label for search filters',
    defaultMessage: 'Cards',
  },
  GROUP: {
    id: 'SearchConstants__ENTITY_TYPES_GROUP',
    description: 'Groups label for search filters',
    defaultMessage: 'Groups',
  },
  PAGE: {
    id: 'SearchConstants__ENTITY_TYPES_PAGES',
    description: 'Pages label for search filters',
    defaultMessage: 'Pages',
  },
  USER: {
    id: 'SearchConstants__ENTITY_TYPES_USER',
    description: 'People label for search filters',
    defaultMessage: 'People',
  },
  AT_MENTION: {
    id: 'SearchConstants__FACETS_AT_MENTION',
    description: 'Search filter label for Mentions',
    defaultMessage: 'Mentions',
  },
  CHANNEL: {
    id: 'SearchConstants__FACETS_CHANNEL',
    description: 'Search filter label for Channel title',
    defaultMessage: 'Channel title',
  },
  CREATE_DATE: {
    id: 'SearchConstants__FACETS__FACETS_CREATE_DATE',
    description: 'Search filter label for Create date',
    defaultMessage: 'Date created in',
  },
  OWNED_BY: {
    id: 'SearchConstants__FACETS__FACETS_CREATOR_NAME',
    description: 'Search filter label for Owned by',
    defaultMessage: 'Owned by',
  },
  DEPARTMENT: {
    id: 'SearchConstants__FACETS__FACETS_DEPARTMENT',
    description: 'Search filter label for In department',
    defaultMessage: 'In department',
  },
  TITLE: {
    id: 'SearchConstants__FACETS__FACETS_TITLE',
    description: 'Search filter label Job Title',
    defaultMessage: 'Has job title',
  },
  MESSAGE_FROM: {
    id: 'SearchConstants__FACETS__FACETS_MESSAGE_FROM',
    description: 'Search filter label Message From',
    defaultMessage: 'Message from',
  },
  CREATOR_NAME: {
    id: 'SearchConstants__FACETS__CREATOR_NAME',
    description: 'Search filter label Created by',
    defaultMessage: 'Created by',
  },
});

export const ENTITY_TYPES = {
  CARD: {
    LABEL: MESSAGES.CARD,
    TYPE: 'card',
    ICON: Icon.OPTIONS.CHART_BAR_VERTICAL,
  },
  USER: {
    LABEL: MESSAGES.USER,
    TYPE: 'user',
    ICON: Icon.OPTIONS.PERSON,
  },
  GROUP: {
    LABEL: MESSAGES.GROUP,
    TYPE: 'group',
    ICON: Icon.OPTIONS.PEOPLE,
  },
  PAGE: {
    LABEL: MESSAGES.PAGE,
    TYPE: 'page',
    ICON: Icon.OPTIONS.PAGES_BARS,
  },
  BUZZ_MESSAGE: {
    LABEL: MESSAGES.BUZZ_MESSAGE,
    TYPE: 'buzz',
    ICON: Icon.OPTIONS.CHAT_BUBBLES,
  },
  BUZZ_CHANNEL: {
    LABEL: MESSAGES.BUZZ_CHANNEL,
    TYPE: 'buzz_channel',
    ICON: Icon.OPTIONS.BUZZ,
  },
};

export const FACET_TYPES = {
  OWNER_ID: MESSAGES.OWNED_BY,
  MESSAGE_FROM_ID: MESSAGES.MESSAGE_FROM,
  AT_MENTION: MESSAGES.AT_MENTION,
  CREATE_DATE: MESSAGES.CREATE_DATE,
  CHANNEL: MESSAGES.CHANNEL,
  TITLE: MESSAGES.TITLE,
  DEPARTMENT: MESSAGES.DEPARTMENT,
  CREATOR_NAME: MESSAGES.CREATOR_NAME,
  TYPE: '',
};

export const DATES = defineMessages({
  LAST_DAY: {
    id: 'SearchConstants__DATE_VALUES__LAST_DAY',
    description:
      'Label for date range, last day, when filtering search results',
    defaultMessage: 'Last day',
  },
  LAST_WEEK: {
    id: 'SearchConstants__DATE_VALUES__LAST_WEEK',
    description:
      'Label for date range, last week, when filtering search results',
    defaultMessage: 'Last week',
  },
  LAST_MONTH: {
    id: 'SearchConstants__DATE_VALUES__LAST_MONTH',
    description:
      'Label for date range, last month, when filtering search results',
    defaultMessage: 'Last month',
  },
  LAST_QUARTER: {
    id: 'SearchConstants__DATE_VALUES__LAST_QUARTER',
    description:
      'Label for date range, last quarter, when filtering search results',
    defaultMessage: 'Last quarter',
  },
  LAST_YEAR: {
    id: 'SearchConstants__DATE_VALUES__LAST_YEAR',
    description:
      'Label for date range, last year, when filtering search results',
    defaultMessage: 'Last year',
  },
});
